export enum MeditationRetreatStatus {
    ENDED = "ENDED",
    UPCOMING = "UPCOMING",
    ONGOING = "ON-GOING",
}